import { connect } from 'react-redux';
import Carport from './Carport';

import { getAnnualResults } from '../../selectors';


const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
});

const combinedActions = { };

export default connect(mapStateToProps, combinedActions)(Carport);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/Carport/index.js